import { Component, Inject, OnInit } from '@angular/core';
import { Obstacle } from '../models/obstacle.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { RunwayService } from '../service/runway.service';
import { TakeoffLandArea } from '../models/takeoff-land-area.model';
import { LatLon } from '../../util/geodesy/latlon';

@Component({
  selector: 'app-edit-area-obstacle',
  templateUrl: './edit-area-obstacle.component.html',
  styleUrls: ['./edit-area-obstacle.component.scss']
})
export class EditAreaObstacleComponent implements OnInit {
  obstacle: Obstacle;
  origObstacle: Obstacle;
  airportId: number;
  takeoffLandAreaId: number;
  isLoading = true;
  isNew = false;
  formGroup: FormGroup;

  constructor(private _matDialogRef: MatDialogRef<EditAreaObstacleComponent>,
              public _snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) data,
              private _runwayService: RunwayService) {
    this.obstacle = data.obstacle || new Obstacle();
    this.airportId = data.airportId;
    this.takeoffLandAreaId = data.takeoffLandAreaId;
    this.isNew = data.isNew || false;
    this.origObstacle = Object.assign(new Obstacle(), data.obstacle);
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      heightAgl: new FormControl(this.obstacle.heightAgl, [Validators.pattern('^\\d{0,10}$')]),
      obstacleType: new FormControl(this.obstacle.obstacleType, [Validators.required, Validators.maxLength(100)]),
      distanceFromEnd: new FormControl(this.obstacle.distanceFromEnd, [Validators.pattern('^\\d{0,10}$')]),
      centerlineOffset: new FormControl(this.obstacle.centerlineOffset, [Validators.pattern('^\\d{0,10}$')]),
      offsetDirection: new FormControl(this.obstacle.offsetDirection, [Validators.maxLength(10)]),
      clearanceSlope: new FormControl(this.obstacle.clearanceSlope, [Validators.pattern('^\\d{0,10}\\.?\\d{0,2}$')]),
      marking: new FormControl(this.obstacle.marking, [Validators.maxLength(200)])
    });
    this.isLoading = false;
  }

  /**
   * triggered by save button click event
   * @return {Promise<void>}
   */
  async save() {
    try {
      let result: any;
      this.obstacle.takeoffLandAreaId = this.takeoffLandAreaId;
      this.obstacle.heightAgl = this.formGroup.value.heightAgl;
      this.obstacle.obstacleType = this.formGroup.value.obstacleType;
      this.obstacle.distanceFromEnd = this.formGroup.value.distanceFromEnd;
      this.obstacle.centerlineOffset = this.formGroup.value.centerlineOffset;
      this.obstacle.offsetDirection = this.formGroup.value.offsetDirection;
      this.obstacle.clearanceSlope = this.formGroup.value.clearanceSlope;
      this.obstacle.marking = this.formGroup.value.marking;

      if (this.isNew) {
        result = await this._runwayService.postObstacle(this.airportId, this.obstacle);
        this.obstacle = Obstacle.parse(result);
      } else {
        result = await this._runwayService.putObstacle(this.airportId, this.obstacle);
        this.obstacle = Obstacle.parse(result);
      }
      this.close({cancelBtnClicked: false, success: true, obstacle: this.obstacle});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false, error: e});
    }
  }


  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    if (data && data.cancelBtnClicked) {
      Object.assign(this.obstacle, this.origObstacle);
    }
    data['isNew'] = this.isNew;
    this._matDialogRef.close(data);
  }
}
